import PropTypes from "prop-types"
import PulseCheckAnswerShape from "./PulseCheckAnswerShape"

const PulseCheckQuestionShape = {
  questionText: PropTypes.string,
  answerSummaries: PropTypes.arrayOf(PropTypes.shape(PulseCheckAnswerShape)),
}

export default PulseCheckQuestionShape



// WEBPACK FOOTER //
// ./src/state/shapes/PulseCheckQuestionShape.js